import {
  Button,
  IconButton,
  MenuItem,
  Select,
  TextField as MUITextField,
  Typography,
} from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import FormHelperText from "@material-ui/core/FormHelperText";
import InputLabel from "@material-ui/core/InputLabel";
import TableRow from "@material-ui/core/TableRow";
import { DatePicker } from "@material-ui/pickers";
import AddRowButton from "components/common/AddRowButton";
import { useAddress } from "components/request-document/components/Address";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import CheckIcon from "@material-ui/icons/Check";
import {
  StyleCheckbox,
  StyledTableCell,
  TableRowHead,
  useStyles,
} from "components/request-document/components/Commons";
import { getErrorMessage, isError } from "libs/utils/form";
import { get } from "lodash";
import React, { useEffect, useState } from "react";

import { useTheme } from "@material-ui/styles";
import ColorButton from "components/common/ColorButton";
import useModalLoading from "libs/hooks/useModalLoading";
import { useDispatch, useSelector } from "react-redux";
import { canEditForm } from "redux/modules/authSlice";
import {
  checkCompany,
  selectCheckCompany,
  companySlice,
} from "redux/modules/companySlice";
import { selectMasterData } from "redux/modules/masterSlice";
import { selectCurrentDocument } from "redux/modules/visaForm";
import HttpClient from "libs/utils/HttpClient";
import { format } from "date-fns";
import moment from "moment";
const TextField = React.memo(MUITextField);

export default function InvestmentThailand({
  defaultGovermentBoundData,
  defaultRealEstateData,
  defaultDirectInvestment,
  formik,
  colSpan = 3,
  mapField = (str) => str,
  disabledBadge = false,
  isChangeMode = false,
  ConditionType,
  smartDate,
}) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const canEdit = useSelector(canEditForm);
  const addressFieldOptions = useAddress({ formik });
  const theme = useTheme();
  const masterData = useSelector(selectMasterData);
  const nationalityConfig = get(masterData, "nationalityConfig", []);
  const [firstTimeChecked, setFirstTimeChecked] = useState(false);
  const { isSuccess, isFailure, data, error } = useSelector(selectCheckCompany);
  const [indexCompany, setIndexCompany] = useState("");
  const [USDRate, setUSDRate] = useState(0);

  const GovernmentBondTable = get(
    formik.values,
    "document.GovernmentBondTable",
    []
  );
  const typeOfbusinessindustryConfig = get(
    masterData,
    "typeOfbusinessindustryConfig",
    []
  );

  const RealEstateTable = get(formik.values, "document.RealEstateTable", []);
  const DirectInvestmentTable = get(
    formik.values,
    "document.DirectInvestmentTable",
    []
  );

  const { showLoading, hideLoading } = useModalLoading();
  const { isLoading } = useSelector(selectCurrentDocument);
  const CompanyRegisterNumber =
    formik.values[mapField("CompanyRegisterNumber")];

  const handleOnCheck = async (id, index) => {
    showLoading();
    dispatch(checkCompany(id));
    setIndexCompany(index);
  };
  // useEffect(() => {
  //   if (isLoading) return;

  //   if (CompanyRegisterNumber && !firstTimeChecked) {
  //     showLoading();
  //     dispatch(checkCompany(CompanyRegisterNumber));
  //     setFirstTimeChecked(true);
  //   } else if (!firstTimeChecked) {
  //     setFirstTimeChecked(true);
  //   }
  // }, [CompanyRegisterNumber, firstTimeChecked, isLoading]);

  useEffect(() => {
    const sumRealEstate = RealEstateTable.filter((x) => !!x.AcquisitionCost)
      .map((xs) => xs.AcquisitionCost)
      .reduce((pv, cur) => parseFloat(pv) + parseFloat(cur), 0);
    const sumGovernmentBond = GovernmentBondTable.filter(
      (x) => !!x.PurchasingAmountTHB
    )
      .map((xs) => xs.PurchasingAmountTHB)
      .reduce((pv, cur) => parseFloat(pv) + parseFloat(cur), 0);
    const sumDirectInvestment = DirectInvestmentTable.filter(
      (x) => !!x.AmountInvestmentTHB
    )
      .map((xs) => xs.AmountInvestmentTHB)
      .reduce((pv, cur) => parseFloat(pv) + parseFloat(cur), 0);

    const Sum = sumRealEstate + sumGovernmentBond + sumDirectInvestment;

    formik.setFieldValue("document.TotalTHB", Sum);
    if (USDRate !== 0) {
      formik.setFieldValue("document.TotalUSD", (Sum / USDRate).toFixed(2));
    }
  }, [
    formik.values.document.RealEstateTable,
    formik.values.document.DirectInvestmentTable,
    formik.values.document.GovernmentBondTable,
  ]);

  const GetCurency = async () => {
    // console.log(smartDate);
    const newDate = moment(smartDate).format("YYYY-MM-DD");

    try {
      const response = await HttpClient.get(
        `/api/master/exchangerate/list?period=${newDate}&currencyCode=USD`
      );

      if (response.status) {
        setUSDRate(response.results.rate);
        return response;
      }
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  };

  useEffect(() => {
    GetCurency();
  }, []);

  useEffect(() => {
    if (isSuccess || isFailure) {
      hideLoading();

      if (isSuccess && indexCompany !== "") {
        formik.setFieldValue(
          `document.DirectInvestmentTable.${indexCompany}.CompanyName`,
          data.companyName
        );
        formik.setFieldValue(
          `document.DirectInvestmentTable.${indexCompany}.InvestmentAddress`,
          data.address
        );

        formik.setFieldValue(
          `document.DirectInvestmentTable.${indexCompany}.OfficeTelephone`,
          data.email
        );
        formik.setFieldValue(
          `document.DirectInvestmentTable.${indexCompany}.ProductsServices`,
          data.desc
        );

        // formik.setFieldValue(mapField("CompanyName"), data.companyName);
        // formik.setFieldValue(mapField("CompanyAddress"), data.address);
        // formik.setFieldValue(mapField("OfficeNumber"), data.phone);
        // formik.setFieldValue(mapField("CompanyWebSite"), data.email);
        // formik.setFieldValue(mapField("ProductService"), data.desc);
      }
    }
  }, [isSuccess, isFailure]);

  useEffect(() => {
    dispatch(companySlice.actions.clearAll());
  }, []);
  // {
  //   console.log(formik.values.document.DirectInvestmentTable);
  // }

  return (
    <>
      <TableRow>
        <StyledTableCell colSpan={7}>
          <div className={classes.cellContent}>
            <div>
              <Typography style={{ fontWeight: "bold" }}>
                Details of investment in Thailand which the applicant has
                invested in{" "}
              </Typography>
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      {/* Direct investment as an individual investor in company */}
      <TableRow>
        <StyledTableCell colSpan={6}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel style={{ fontWeight: "bold" }}></InputLabel>
              <FormGroup row>
                <FormControlLabel
                  control={
                    <StyleCheckbox
                      disabled={!canEdit}
                      name="document.GovernmentBond"
                      checked={formik.values.document.GovernmentBond === "true"}
                      onClick={() => {
                        formik.setFieldValue(
                          "document.GovernmentBond",
                          formik.values.document.GovernmentBond === "true"
                            ? "false"
                            : "true"
                        );
                      }}
                    />
                  }
                  label="1.1 Thai government bonds issued by Ministry of Finance"
                />
              </FormGroup>
              {formik.values.document.GovernmentBond === "true" ? (
                <TableRow style={{ margin: 0, padding: 0 }}>
                  <StyledTableCell
                    colSpan={7}
                    style={{ margin: 0, padding: 0, border: 0 }}
                  >
                    <TableRowHead>
                      <StyledTableCell>
                        <InputLabel>Bond symbol /Bond name</InputLabel>
                      </StyledTableCell>
                      <StyledTableCell>
                        <InputLabel>Purchasing Amount (THB) </InputLabel>
                      </StyledTableCell>
                      <StyledTableCell>
                        <InputLabel>Issue Date (DD-MM-YYYY)</InputLabel>
                      </StyledTableCell>
                      <StyledTableCell>
                        <InputLabel>Maturity date (DD-MM-YYYY)</InputLabel>
                      </StyledTableCell>
                      <StyledTableCell>
                        <InputLabel>Age/Term (Years)</InputLabel>
                      </StyledTableCell>
                    </TableRowHead>

                    {GovernmentBondTable.map((data, index) => {
                      console.log(data);
                      if (!data.Status) return null;
                      return (
                        <TableRow key={index}>
                          <StyledTableCell>
                            <TextField
                              disabled={!canEdit}
                              variant="outlined"
                              className={classes.textField}
                              style={{ width: 100 }}
                              placeholder=""
                              name={`document.GovernmentBondTable.${index}.BondName`}
                              value={get(
                                formik.values,
                                `document.GovernmentBondTable.${index}.BondName`,
                                ""
                              )}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={isError(
                                `document.GovernmentBondTable.${index}.BondName`,
                                formik
                              )}
                              helperText={getErrorMessage(
                                `document.GovernmentBondTable.${index}.BondName`,
                                formik
                              )}
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            <TextField
                              disabled={!canEdit}
                              variant="outlined"
                              className={classes.textField}
                              style={{ width: 100 }}
                              type="number"
                              placeholder=""
                              name={`document.GovernmentBondTable.${index}.PurchasingAmountTHB`}
                              value={get(
                                formik.values,
                                `document.GovernmentBondTable.${index}.PurchasingAmountTHB`,
                                ""
                              )}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={isError(
                                `document.GovernmentBondTable.${index}.PurchasingAmountTHB`,
                                formik
                              )}
                              helperText={getErrorMessage(
                                `document.GovernmentBondTable.${index}.PurchasingAmountTHB`,
                                formik
                              )}
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            <DatePicker
                              // style={{ width: 200 }}
                              className={classes.formControl}
                              inputVariant="outlined"
                              disableFuture={false}
                              openTo="year"
                              format="DD-MM-YYYY"
                              label="Issue Date
                              "
                              views={["year", "month", "date"]}
                              name={`document.GovernmentBondTable.${index}.IssueDate`}
                              value={
                                get(
                                  formik.values,
                                  `document.GovernmentBondTable.${index}.IssueDate`,
                                  null
                                ) || null
                              }
                              onChange={(date) => {
                                formik.setFieldValue(
                                  `document.GovernmentBondTable.${index}.IssueDate`,
                                  date.format("YYYY-MM-DD")
                                );
                              }}
                              error={isError(
                                `document.GovernmentBondTable.${index}.IssueDate`,
                                formik
                              )}
                              helperText={getErrorMessage(
                                `document.GovernmentBondTable.${index}.IssueDate`,
                                formik
                              )}
                              disabled={!canEdit}
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            <DatePicker
                              // style={{ width: 200 }}
                              className={classes.formControl}
                              inputVariant="outlined"
                              disableFuture={false}
                              openTo="year"
                              format="DD-MM-YYYY"
                              label="Maturity date"
                              views={["year", "month", "date"]}
                              name={`document.GovernmentBondTable.${index}.MaturityDate`}
                              value={
                                get(
                                  formik.values,
                                  `document.GovernmentBondTable.${index}.MaturityDate`,
                                  null
                                ) || null
                              }
                              onChange={(date) => {
                                formik.setFieldValue(
                                  `document.GovernmentBondTable.${index}.MaturityDate`,
                                  date.format("YYYY-MM-DD")
                                );
                              }}
                              error={isError(
                                `document.GovernmentBondTable.${index}.MaturityDate`,
                                formik
                              )}
                              helperText={getErrorMessage(
                                `document.GovernmentBondTable.${index}.MaturityDate`,
                                formik
                              )}
                              disabled={!canEdit}
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            <TextField
                              disabled={!canEdit}
                              variant="outlined"
                              className={classes.textField}
                              style={{ width: 100 }}
                              placeholder=""
                              name={`document.GovernmentBondTable.${index}.AgeYear`}
                              value={get(
                                formik.values,
                                `document.GovernmentBondTable.${index}.AgeYear`,
                                ""
                              )}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={isError(
                                `document.GovernmentBondTable.${index}.AgeYear`,
                                formik
                              )}
                              helperText={getErrorMessage(
                                `document.GovernmentBondTable.${index}.AgeYear`,
                                formik
                              )}
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            {index === 0 ? (
                              <div style={{ width: 35 }} />
                            ) : (
                              <>
                                <IconButton
                                  disabled={!canEdit}
                                  style={{
                                    width: 35,
                                    color: theme.palette.error.main,
                                  }}
                                  size="small"
                                  onClick={async () => {
                                    if (
                                      get(
                                        formik.values,
                                        `document.GovernmentBondTable.${index}.GovernmentBondID`,
                                        ""
                                      )
                                    ) {
                                      formik.setFieldValue(
                                        `document.GovernmentBondTable[${index}].Status`,
                                        false
                                      );
                                    } else {
                                      formik.setFieldValue(
                                        "document.GovernmentBondTable",
                                        GovernmentBondTable.filter(
                                          (__, i) => i !== index
                                        )
                                      );
                                    }
                                  }}
                                >
                                  <DeleteForeverIcon />
                                </IconButton>
                                <FormHelperText error={false}> </FormHelperText>
                              </>
                            )}
                          </StyledTableCell>
                        </TableRow>
                      );
                    })}

                    <TableRow>
                      <StyledTableCell colSpan={7}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <AddRowButton
                            disabled={!canEdit}
                            onClick={() => {
                              formik.setFieldValue(
                                "document.GovernmentBondTable",
                                [
                                  ...GovernmentBondTable,
                                  defaultGovermentBoundData,
                                ]
                              );
                            }}
                          />
                        </div>
                      </StyledTableCell>
                    </TableRow>
                  </StyledTableCell>
                </TableRow>
              ) : null}
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      {/* End Direct investment as an individual investor in company */}
      {/* Direct investment as an individual investor in company */}
      <TableRow>
        <StyledTableCell colSpan={7}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel style={{ fontWeight: "bold" }}></InputLabel>
              <FormGroup row>
                <FormControlLabel
                  control={
                    <StyleCheckbox
                      disabled={!canEdit}
                      name="document.DirectInvestment"
                      checked={
                        formik.values.document.DirectInvestment === "true"
                      }
                      onClick={() => {
                        formik.setFieldValue(
                          "document.DirectInvestment",
                          formik.values.document.DirectInvestment === "true"
                            ? "false"
                            : "true"
                        );
                      }}
                    />
                  }
                  label="1.2 Direct investment as an individual investor in company "
                />
              </FormGroup>
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      {formik.values.document.DirectInvestment === "true" ? (
        <>
          {DirectInvestmentTable.map((data, index) => {
            if (!data.Status) return null;
            return (
              <>
                <TableRow>
                  <StyledTableCell colSpan={7}>No. {index + 1}</StyledTableCell>
                </TableRow>
                <TableRow>
                  <StyledTableCell colSpan={3}>
                    <div className={classes.cellContent}>
                      <div className={classes.wrapField}>
                        <InputLabel>Registration number</InputLabel>
                        <div style={{ display: "flex" }}>
                          <TextField
                            disabled={!canEdit}
                            variant="outlined"
                            className={classes.textField}
                            InputProps={{
                              classes: {
                                root:
                                  indexCompany !== index
                                    ? " "
                                    : isSuccess
                                    ? classes.textFieldSuccess
                                    : undefined,
                                notchedOutline:
                                  indexCompany !== index
                                    ? " "
                                    : isSuccess
                                    ? classes.notchedOutlineSuccess
                                    : undefined,
                              },
                              endAdornment:
                                indexCompany !== index ? (
                                  " "
                                ) : isSuccess ? (
                                  <CheckIcon />
                                ) : null,
                            }}
                            FormHelperTextProps={{
                              classes: {
                                root:
                                  indexCompany !== index
                                    ? " "
                                    : isSuccess
                                    ? classes.textSuccess
                                    : undefined,
                              },
                            }}
                            // type="number"
                            name={`document.DirectInvestmentTable.${index}.RegistrationNumber`}
                            value={
                              get(
                                formik.values,
                                `document.DirectInvestmentTable.${index}.RegistrationNumber`,
                                null
                              ) || null
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={indexCompany !== index ? false : isFailure}
                            helperText={
                              indexCompany !== index
                                ? " "
                                : isSuccess
                                ? "success"
                                : error?.message || " "
                            }
                          />
                          <ColorButton
                            color="primary"
                            variant="contained"
                            disabled={!canEdit}
                            style={{ marginLeft: 5 }}
                            onClick={() =>
                              handleOnCheck(
                                get(
                                  formik.values,
                                  `document.DirectInvestmentTable.${index}.RegistrationNumber`,
                                  null
                                ),
                                index
                              )
                            }
                          >
                            Check
                          </ColorButton>
                        </div>
                      </div>
                    </div>
                  </StyledTableCell>
                  <StyledTableCell colSpan={4}>
                    <div className={classes.cellContent}>
                      <div className={classes.wrapField}>
                        <InputLabel>Company name</InputLabel>
                        <TextField
                          variant="outlined"
                          className={classes.textField}
                          name={`document.DirectInvestmentTable.${index}.CompanyName`}
                          value={
                            get(
                              formik.values,
                              `document.DirectInvestmentTable.${index}.CompanyName`,
                              null
                            ) || null
                          }
                          onChange={
                            isChangeMode ? undefined : formik.handleChange
                          }
                          onBlur={isChangeMode ? undefined : formik.handleBlur}
                          error={isError(
                            `document.DirectInvestmentTable.${index}.CompanyName`,
                            formik
                          )}
                          helperText={getErrorMessage(
                            `document.DirectInvestmentTable.${index}.CompanyName`,
                            formik
                          )}
                          disabled={
                            !isSuccess
                              ? true
                              : isChangeMode
                              ? ConditionType !== "CN"
                              : true || !canEdit
                          }
                        />
                      </div>
                    </div>
                  </StyledTableCell>
                </TableRow>

                <TableRow>
                  <StyledTableCell colSpan={3}>
                    <div className={classes.cellContent}>
                      <div className={classes.wrapField}>
                        <InputLabel>
                          Amount of your investment capital (THB)
                        </InputLabel>
                        <TextField
                          disabled={!canEdit}
                          variant="outlined"
                          className={classes.textField}
                          name={`document.DirectInvestmentTable.${index}.AmountInvestmentTHB`}
                          value={
                            get(
                              formik.values,
                              `document.DirectInvestmentTable.${index}.AmountInvestmentTHB`,
                              null
                            ) || null
                          }
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                      </div>
                    </div>
                  </StyledTableCell>
                  <StyledTableCell colSpan={4}>
                    <div className={classes.cellContent}>
                      <div className={classes.wrapField}>
                        <InputLabel>Type of business industry</InputLabel>
                        <Select
                          variant="outlined"
                          name={`document.DirectInvestmentTable.${index}.typeOfbusinessindustryID`}
                          value={
                            get(
                              formik.values,
                              `document.DirectInvestmentTable.${index}.typeOfbusinessindustryID`,
                              null
                            ) || null
                          }
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        >
                          {typeOfbusinessindustryConfig.map((x) => (
                            <MenuItem
                              key={x.typeOfbusinessindustryID}
                              value={x.typeOfbusinessindustryID}
                            >
                              {x.typeOfbusinessindustryName}
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                    </div>
                  </StyledTableCell>
                </TableRow>
                <TableRow>
                  <StyledTableCell colSpan={3}>
                    <div className={classes.cellContent}>
                      <div className={classes.wrapField}>
                        <InputLabel>Address</InputLabel>
                        <TextField
                          disabled={!canEdit}
                          variant="outlined"
                          className={classes.textField}
                          name={`document.DirectInvestmentTable.${index}.InvestmentAddress`}
                          value={
                            get(
                              formik.values,
                              `document.DirectInvestmentTable.${index}.InvestmentAddress`,
                              null
                            ) || null
                          }
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                      </div>
                    </div>
                  </StyledTableCell>
                  <StyledTableCell colSpan={4}>
                    <div className={classes.cellContent}>
                      <div className={classes.wrapField}>
                        <InputLabel>
                          Company website or e-mail address
                        </InputLabel>
                        <TextField
                          disabled={!canEdit}
                          variant="outlined"
                          className={classes.textField}
                          name={`document.DirectInvestmentTable.${index}.OfficeTelephone`}
                          value={
                            get(
                              formik.values,
                              `document.DirectInvestmentTable.${index}.OfficeTelephone`,
                              null
                            ) || null
                          }
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                      </div>
                    </div>
                  </StyledTableCell>
                </TableRow>
                <TableRow>
                  <StyledTableCell colSpan={6}>
                    <div className={classes.cellContent}>
                      <div className={classes.wrapField}>
                        <InputLabel>
                          Business/products or services description
                        </InputLabel>
                        <TextField
                          disabled={!canEdit}
                          variant="outlined"
                          className={classes.textField}
                          name={`document.DirectInvestmentTable.${index}.ProductsServices`}
                          value={
                            get(
                              formik.values,
                              `document.DirectInvestmentTable.${index}.ProductsServices`,
                              null
                            ) || null
                          }
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                      </div>
                    </div>
                  </StyledTableCell>
                </TableRow>
                <TableRow>
                  <StyledTableCell colSpan={6}>
                    {index === 0 ? (
                      <div style={{ width: 35 }} />
                    ) : (
                      <>
                        <Button
                          disabled={!canEdit}
                          style={{
                            width: 35,
                            color: theme.palette.error.main,
                          }}
                          variant="outlined"
                          onClick={async () => {
                            if (
                              get(
                                formik.values,
                                `document.DirectInvestmentTable.${index}.DirectInvestmentID`,
                                ""
                              )
                            ) {
                              formik.setFieldValue(
                                `document.DirectInvestmentTable[${index}].Status`,
                                false
                              );
                            } else {
                              formik.setFieldValue(
                                "document.DirectInvestmentTable",
                                DirectInvestmentTable.filter(
                                  (__, i) => i !== index
                                )
                              );
                            }
                          }}
                        >
                          Delete
                        </Button>
                        <FormHelperText error={false}> </FormHelperText>
                      </>
                    )}
                  </StyledTableCell>
                </TableRow>
              </>
            );
          })}
          <TableRow>
            <StyledTableCell colSpan={7}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <AddRowButton
                  disabled={!canEdit}
                  onClick={() => {
                    formik.setFieldValue("document.DirectInvestmentTable", [
                      ...DirectInvestmentTable,
                      defaultDirectInvestment,
                    ]);
                  }}
                />
              </div>
            </StyledTableCell>
          </TableRow>
        </>
      ) : null}

      {/* End Direct investment as an individual investor in company */}
      {/* 1.3 Real estate */}
      <TableRow>
        <StyledTableCell colSpan={6}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel style={{ fontWeight: "bold" }}></InputLabel>
              <FormGroup row>
                <FormControlLabel
                  control={
                    <StyleCheckbox
                      disabled={!canEdit}
                      name="document.RealEstate"
                      checked={formik.values.document.RealEstate === "true"}
                      onClick={() => {
                        formik.setFieldValue(
                          "document.RealEstate",
                          formik.values.document.RealEstate === "true"
                            ? "false"
                            : "true"
                        );
                      }}
                    />
                  }
                  label="1.3 Real estate (Condominium)"
                />
              </FormGroup>
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
      {formik.values.document.RealEstate === "true" ? (
        <TableRow style={{ margin: 0, padding: 0 }}>
          <StyledTableCell
            colSpan={7}
            style={{ margin: 0, padding: 0, border: 0 }}
          >
            <TableRowHead>
              <StyledTableCell>
                <InputLabel>Property name</InputLabel>
              </StyledTableCell>
              <StyledTableCell>
                <InputLabel>Address </InputLabel>
              </StyledTableCell>
              <StyledTableCell>
                <InputLabel>Date of ownership (DD-MM-YYYY)</InputLabel>
              </StyledTableCell>
              <StyledTableCell>
                <InputLabel>Acquisition cost (THB)</InputLabel>
              </StyledTableCell>
            </TableRowHead>

            {RealEstateTable.map((data, index) => {
              if (!data.Status) return null;

              return (
                <TableRow key={index}>
                  <StyledTableCell>
                    <TextField
                      disabled={!canEdit}
                      variant="outlined"
                      className={classes.textField}
                      style={{ width: 100 }}
                      placeholder=""
                      name={`document.RealEstateTable.${index}.PropertyName`}
                      value={get(
                        formik.values,
                        `document.RealEstateTable.${index}.PropertyName`,
                        ""
                      )}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={isError(
                        `document.RealEstateTable.${index}.PropertyName`,
                        formik
                      )}
                      helperText={getErrorMessage(
                        `document.RealEstateTable.${index}.PropertyName`,
                        formik
                      )}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <TextField
                      disabled={!canEdit}
                      variant="outlined"
                      className={classes.textField}
                      style={{ width: 100 }}
                      placeholder=""
                      name={`document.RealEstateTable.${index}.Address`}
                      value={get(
                        formik.values,
                        `document.RealEstateTable.${index}.Address`,
                        ""
                      )}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={isError(
                        `document.RealEstateTable.${index}.Address`,
                        formik
                      )}
                      helperText={getErrorMessage(
                        `document.RealEstateTable.${index}.Address`,
                        formik
                      )}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <DatePicker
                      // style={{ width: 200 }}
                      className={classes.formControl}
                      inputVariant="outlined"
                      disableFuture={false}
                      openTo="year"
                      format="DD-MM-YYYY"
                      label="Maturity date"
                      views={["year", "month", "date"]}
                      name={`document.RealEstateTable.${index}.DateOwnership`}
                      value={
                        get(
                          formik.values,
                          `document.RealEstateTable.${index}.DateOwnership`,
                          null
                        ) || null
                      }
                      onChange={(date) => {
                        formik.setFieldValue(
                          `document.RealEstateTable.${index}.DateOwnership`,
                          date.format("YYYY-MM-DD")
                        );
                      }}
                      error={isError(
                        `document.RealEstateTable.${index}.DateOwnership`,
                        formik
                      )}
                      helperText={getErrorMessage(
                        `document.RealEstateTable.${index}.DateOwnership`,
                        formik
                      )}
                      disabled={!canEdit}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <TextField
                      disabled={!canEdit}
                      variant="outlined"
                      className={classes.textField}
                      style={{ width: 100 }}
                      placeholder=""
                      type="number"
                      name={`document.RealEstateTable.${index}.AcquisitionCost`}
                      value={get(
                        formik.values,
                        `document.RealEstateTable.${index}.AcquisitionCost`,
                        ""
                      )}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={isError(
                        `document.RealEstateTable.${index}.AcquisitionCost`,
                        formik
                      )}
                      helperText={getErrorMessage(
                        `document.RealEstateTable.${index}.AcquisitionCost`,
                        formik
                      )}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    {index === 0 ? (
                      <div style={{ width: 35 }} />
                    ) : (
                      <>
                        <IconButton
                          disabled={!canEdit}
                          style={{
                            width: 35,
                            color: theme.palette.error.main,
                          }}
                          size="small"
                          onClick={async () => {
                            if (
                              get(
                                formik.values,
                                `document.RealEstateTable.${index}.RealEstateID`,
                                ""
                              )
                            ) {
                              formik.setFieldValue(
                                `document.RealEstateTable[${index}].Status`,
                                false
                              );
                            } else {
                              formik.setFieldValue(
                                "document.RealEstateTable",
                                RealEstateTable.filter((__, i) => i !== index)
                              );
                            }
                          }}
                        >
                          <DeleteForeverIcon />
                        </IconButton>
                        <FormHelperText error={false}> </FormHelperText>
                      </>
                    )}
                  </StyledTableCell>
                </TableRow>
              );
            })}

            <TableRow>
              <StyledTableCell colSpan={7}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <AddRowButton
                    disabled={!canEdit}
                    onClick={() => {
                      formik.setFieldValue("document.RealEstateTable", [
                        ...RealEstateTable,
                        defaultRealEstateData,
                      ]);
                    }}
                  />
                </div>
              </StyledTableCell>
            </TableRow>
          </StyledTableCell>
        </TableRow>
      ) : null}
      {/* End 1.3 Real estate */}
      <TableRow>
        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>
                Total investment in Thailand (1.1+1.2+1.3)
              </InputLabel>
            </div>
          </div>
        </StyledTableCell>

        <StyledTableCell colSpan={2}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>THB</InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name="document.TotalTHB"
                value={formik.values.document.TotalTHB}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                type="number"
                inputProps={{ readOnly: true }}
                error={isError("document.TotalTHB", formik)}
                helperText={getErrorMessage("document.TotalTHB", formik)}
              />
            </div>
          </div>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>USD</InputLabel>
              <TextField
                disabled={!canEdit}
                variant="outlined"
                className={classes.textField}
                name="document.TotalUSD"
                inputProps={{ readOnly: true }}
                value={formik.values.document.TotalUSD}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                type="number"
                error={isError("document.TotalUSD", formik)}
                helperText={getErrorMessage("document.TotalUSD", formik)}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
    </>
  );
}
